import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'
import Con from '../../../static/config.json'

export default {
  data() {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      dateNow: this.dateMonth(new Date()),
      data_compare: '',
      data_list: [],
      data_month: '',
      sum_receive: 0,
      sum_expense: 0,
      pdf_url: baseUrl + 'pdf/compare_pdf.php',
      excel_url: baseUrl + 'excel/compare_excel.php',
      header: {
        headers: {
          'access-token': this.$store.state.token,
        },
      },
      modal_data_str: '',
      modal_data: {
        db_year: '0',
        db_month: '1',
        doc_name: '',
        sum_amount: '0',
        detail_data: [],
      },
    }
  },
  components: {
    apexchart: VueApexCharts,
  },
  methods: {
    getCompare() {
      this.$store.state.isLoading = true
      api.getDiffMonth(
        {
          date: moment(this.dateNow).format('YYYY-MM-DD'),
        },
        this.header,
        (result) => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_month = this.monthYearFormat(this.dateNow)
            this.data_compare = JSON.stringify(result.data)
            this.data_list = result.data
            this.sum_receive = 0
            this.sum_expense = 0
            this.data_list.receive_data.forEach((val) => {
              this.sum_receive += parseFloat(val['receive_amount'])
            })
            this.data_list.expense_data.forEach((val) => {
              this.sum_expense += parseFloat(val['expense_amount'])
            })
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        (error) => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        },
      )
    },
    getDetail(obj, type) {
      var doc_name = type == 1 ? obj.receive_name : (type == 2 ? obj.expense_name : obj.other_name)
      var doc_num = type == 1 ? obj.receive_num : (type == 2 ? obj.expense_num : obj.other_num)
      var data = {
        year: obj.doc_year,
        month: obj.doc_month,
        doc_name: doc_name,
        doc_num: doc_num,
        active_page: 1,
        per_page: 10000000,
      }
      this.$store.state.isLoading = true
      api.getCompareDetail(
        data,
        this.header,
        (result) => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.modal_data = result.data
            this.modal_data_str = JSON.stringify(this.modal_data)
            $('#detailModal').modal({
              show: true,
              backdrop: 'static',
            })
          } else {
            Swal.fire('ดึงข้อมูลรายละเอียด', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        (error) => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        },
      )
    },
  },
  mounted() {
    this.getCompare()
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/compare_report.js